import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useGlobalContext } from '../../context/GlobalContext';

import { useForm } from 'react-hook-form';
import PromptRouter from '../../partials/PromptRouter';
import SelectMedia from '../medias/SelectMedia';
import RemoveModale from '../../partials/RemoveModale/RemoveModale';
import Picture from '../medias/Picture';

import { getCompanyAction } from '../../../actions/companiesActions';
import { getMediasAction } from '../../../actions/mediasActions';
import { getPageAction, updatePageAction } from '../../../actions/themeActions';

import '../../../styles/pages-sites.scss';
import TextEditor from '../../partials/TextEditor';
import MetaSeo from '../../partials/MetaSeo';

export default function HomeGroup({
  setDisplayNavBar,
  setDisplaySelectLang,
  setDisplaySiteNav,
  setActivePage,
  theme,
  lang,
}) {
  const param = useParams();
  const page = 'home';
  const { handleSubmit, errors } = useForm();
  const [context, dispatch] = useGlobalContext();
  const homeRef = useRef({});
  const [seoDraft, setSeoDraft] = useState();
  const [isSaved, setIsSaved] = useState(true);
  const [isMounted, setIsMounted] = useState(false);
  const [publishIsLoading, setPublishIsLoading] = useState(false);
  const [displaySelectMedia, setDisplaySelectMedia] = useState(false);
  const [selectedMediaList, setSelectedMediaList] = useState([]);
  const [mediaIsMulti, setMediaIsMulti] = useState(false);
  const [mediaType, setMediaType] = useState();
  const [mediaKey, setMediaKey] = useState('picture1');
  const [removeAction, setRemoveAction] = useState();
  const [picture1, setPicture1] = useState(null);

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch, param.companyId);
    getMediasAction(dispatch, param.companyId);
  }, [dispatch, param.companyId]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true);
    setActivePage('home-group');
    getCompany();
    return () => {
      setDisplaySelectLang(false);
      setIsMounted(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getPageAction(dispatch, param.companyId, page, lang);
    setIsMounted(false);
    dispatch({
      type: 'RESET_PAGE',
    });
    // eslint-disable-next-line
  }, [lang]);

  useEffect(() => {
    if (context.theme.page) {
      homeRef.current = {
        title: context.theme.page.title,
        text: context.theme.page.text,
        seo: context.theme.page.seo,
        picture1: context.theme.page.picture1,
        button: context.theme.page.button,
        buttonUrl: context.theme.page.buttonUrl,
        articlesTitle: context.theme.page.articlesTitle,
        articlesText: context.theme.page.articlesText,
      };
      setPicture1(context.theme.page.picture1 || null);
      setSeoDraft(context.theme.page.seo);
      setIsSaved(true);
      setIsMounted(true);
    } else {
      setSeoDraft(undefined);
      setPicture1(null);
      setIsMounted(false);
    }

    dispatch({
      type: 'MESSAGE_PAGE',
      payload: null,
    });
    // eslint-disable-next-line
  }, [context.theme.page]);

  useEffect(() => {
    if (context.theme && context?.theme?.message === 'Theme successfully updated') {
      setPublishIsLoading(false);
      setIsSaved(true);

      dispatch({
        type: 'MESSAGE_PAGE',
        payload: null,
      });

      dispatch({
        type: 'SET_TOAST',
        payload: {
          message: 'La page a bien été enregistré',
          type: 'success',
        },
      });
    }
    // eslint-disable-next-line
  }, [context.theme.message]);

  function submitMedia(value) {
    const updatedPicture = value[0];
    homeRef.current = { ...homeRef.current, picture1: updatedPicture };
    setPicture1(updatedPicture);
    setIsSaved(false);
    setMediaKey();
  }

  function openSelectPicture() {
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('picture1');
    setMediaType('image');
    if (picture1?._id || picture1) {
      setSelectedMediaList([picture1._id || picture1]);
    } else {
      setSelectedMediaList([]);
    }
  }

  const submitGroup = (values) => {
    setPublishIsLoading(true);

    const groupData = { ...homeRef.current };
    const obj = {};

    for (const [key, value] of Object.entries(groupData)) {
      obj[`${page}.${key}`] = value;
    }

    updatePageAction(dispatch, context.companies.company.theme[lang], 'group', page, obj);

    dispatch({
      type: 'ERROR_PAGE',
      payload: null,
    });

    dispatch({
      type: 'MESSAGE_PAGE',
      payload: null,
    });
  };

  function handleChange(value, obj) {
    if (isSaved) {
      setIsSaved(false);
    }
    homeRef.current = { ...homeRef.current, [obj]: value };
  }

  function renderEdit() {
    return (
      <div className="list-item transition edit-row">
        <form onSubmit={handleSubmit(submitGroup)} autoComplete="nope">
          <div className="form-row">
            <div className="col-1">
              <label htmlFor="title">Titre</label>
              <textarea
                id="title"
                name="title"
                onChange={(e) => handleChange(e.target.value, 'title')}
                defaultValue={homeRef && homeRef.current?.title ? homeRef.current?.title : ''}
              />
              <p className="error">{errors && errors.title && errors.title.message}</p>

              <label>Paragraphe</label>
              <TextEditor
                value={homeRef && homeRef?.current?.text}
                onChange={(val) => handleChange(val, 'text')}
              />

              <label htmlFor="button">Libellé du bouton</label>
              <input
                id="button"
                name="button"
                type="text"
                onChange={(e) => handleChange(e.target.value, 'button')}
                defaultValue={homeRef?.current?.button || ''}
              />

              <label htmlFor="buttonUrl">URL du bouton</label>
              <input
                id="buttonUrl"
                name="buttonUrl"
                type="text"
                onChange={(e) => handleChange(e.target.value, 'buttonUrl')}
                defaultValue={homeRef?.current?.buttonUrl || ''}
              />
              <p className="note">Exemple : /groupe/fr ou https://example.com</p>

              <label>Image d&apos;illustration (carré à droite)<br /><span className="note">minimum 600 x 600 px , 72 dpi</span></label>
              <Picture picture={picture1} />
              <div className="btn-container" style={{ marginBottom: 20 }}>
                <button
                  type="button"
                  style={{ marginRight: 20 }}
                  className={`btn primary ${theme}-bg`}
                  onClick={openSelectPicture}
                >
                  Parcourir
                </button>
                {picture1 && (
                  <button
                    type="button"
                    className={`btn primary ${theme}-bg`}
                    onClick={() => setRemoveAction({
                      function: () => {
                        homeRef.current = { ...homeRef.current, picture1: null };
                        setPicture1(null);
                        setIsSaved(false);
                      },
                    })}
                  >
                    Supprimer
                  </button>
                )}
              </div>

              <label htmlFor="articlesTitle">Titre de la section actualités</label>
              <textarea
                id="articlesTitle"
                name="articlesTitle"
                onChange={(e) => handleChange(e.target.value, 'articlesTitle')}
                defaultValue={homeRef?.current?.articlesTitle || ''}
              />

              <label>Texte de la section actualités</label>
              <TextEditor
                value={homeRef?.current?.articlesText}
                onChange={(val) => handleChange(val, 'articlesText')}
              />

              <p className="note">
                La section actualités utilise une grille de 3 colonnes. Les articles
                tagués <strong>Home</strong> occupent 1 colonne. Jusqu&apos;à 3 articles{' '}
                <strong>Home Large</strong> peuvent s&apos;afficher en 2 colonnes sur les
                lignes 2, 4 et 6 (sinon ils s&apos;affichent comme un Home classique).
              </p>
            </div>

            <div className="col-2">
              <div className="btn-actions-container">
                {!publishIsLoading && (
                  <button className={`btn primary publish ${theme}-bg`} type="submit">
                    Publier
                  </button>
                )}
              </div>
            </div>
          </div>

          <MetaSeo
            seo={seoDraft}
            onChange={(seoData) => {
              homeRef.current = { ...homeRef.current, seo: seoData };
              setSeoDraft(seoData);
              setIsSaved(false);
            }}
            theme={theme}
            companyId={param.companyId}
          />
        </form>
      </div>
    );
  }

  return (
    <>
      <PromptRouter when={!isSaved} />
      {removeAction && (
        <RemoveModale
          removeAction={removeAction}
          setRemoveAction={setRemoveAction}
        />
      )}
      {displaySelectMedia && (
        <SelectMedia
          displaySelectMedia={displaySelectMedia}
          dispatch={dispatch}
          theme={theme}
          context={context}
          mediaType={mediaType}
          selectedMediaList={selectedMediaList}
          companyId={param.companyId}
          isMulti={mediaIsMulti}
          handleChange={(value) => submitMedia(value)}
          setDisplaySelectMedia={setDisplaySelectMedia}
        />
      )}
      {isMounted && homeRef.current && (
        <div className={`page-container site ${theme}`}>
          <div className="page-content">
            <div className="title-row space-between">
              <div className="flex">
                <div className="title">
                  <h1>Edition de la page d&apos;accueil ({lang})</h1>
                  <div className="bar primary"></div>
                </div>
              </div>
            </div>

            <div className="list-container">{renderEdit()}</div>
          </div>
        </div>
      )}
    </>
  );
}
